import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/tresno/projects/watchinspect-nextjs/node_modules/next/dist/client/app-dir/link.js");
